import gql from "graphql-tag";

export const updateRoleMutation = gql`
  mutation updateRole($name: String!, $id: ID!, $permissions: [ID!]!) {
    updateRole(name: $name, id: $id, permissions: $permissions) {
      id
    }
  }
`;
